import script from "./StatCountry.vue?vue&type=script&setup=true&lang=js"
export * from "./StatCountry.vue?vue&type=script&setup=true&lang=js"

import "./StatCountry.vue?vue&type=style&index=0&id=597a0a38&scoped=true&lang=css"

import exportComponent from "/var/lib/docker/jenkins_home/workspace/spider-web-gp-tools-s3-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-597a0a38"]])

export default __exports__